import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/arab-hardware/pages/SiteLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/basic/pages/SiteLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/black-and-white/pages/SiteLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/farah-omar/pages/SiteLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/modern/pages/SiteLayout.tsx");
